module.exports = __webpack_public_path__ + "static/media/1.fbac5e4c.jpeg";